






















































































import { WhooingEntryModel } from "@/models/WhooingEntryModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  EntriesDuplicationHelper,
  IKeyObject,
} from "../helpers/EntriesDuplicationHelper";
import { IMergeSelected } from "../models/IMergeSelected";
import { UserHelper } from "../store/modules/User";

interface IDuplicationGroupModel {
  key: string;
  data: WhooingEntryModel[];
}

@Component
export default class DuplicationGroup extends Vue {
  @Prop({ type: Object, required: true })
  public value!: IDuplicationGroupModel;

  @Prop({ type: String, required: true })
  public sId!: string;

  public selectedIds: number[] = [];

  public mergeSelected: IMergeSelected | null = null;

  public get keyObject(): IKeyObject {
    return EntriesDuplicationHelper.parseKey(this.value.key);
  }

  public get keyTags(): string[] {
    return [];
  }

  @Watch("value")
  public onValue() {
    if(this.value.data.some((o)=> !this.selectedIds.includes(o.entry_id))) {
      this.selectedIds = [];
    }
  }

  @Watch("selectedIds")
  public onSelectedIds() {
    const selectedLength = this.selectedIds.length;
    if (selectedLength === 0) {
      this.mergeSelected = null;
    } else if (selectedLength === 1 || !this.mergeSelected) {
      const selectedItem = this.value.data.find(
        (o) => o.entry_id === this.selectedIds[0],
      );
      if (selectedItem) {
        this.mergeSelected = {
          date: selectedItem.entry_date.split(".")[0],
          item: selectedItem.item,
          memo: selectedItem.memo,
          money: selectedItem.money,
          left: selectedItem.l_account_id,
          right: selectedItem.r_account_id,
        };
      }
    }
  }

  public selectAll() {
    this.selectedIds = this.value.data.map((o) => o.entry_id);
  }

  public merge() {
    this.$emit("merge", this.mergeSelected, this.selectedIds);
  }
}
